import { render, staticRenderFns } from "./MobileNavigationButton.vue?vue&type=template&id=39e45481&scoped=true"
import script from "./MobileNavigationButton.vue?vue&type=script&lang=js"
export * from "./MobileNavigationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e45481",
  null
  
)

export default component.exports